
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#08C1AB","d":"M40.44 23.25a4 4 0 014.46-3.48l12.58 1.54a4 4 0 013.48 4.46l-.28 2.25-20.82-.04.58-4.73z"}}),_c('path',{attrs:{"fill":"#9FFCEA","fill-rule":"evenodd","d":"M26.07 10.61a4 4 0 00-4.56 3.35l-1.49 9.78a4 4 0 003.96 4.6h13.68l.67-4.31a7 7 0 016.64-5.93l.08-.53a4 4 0 00-3.34-4.54L26.07 10.6z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#0AA89D","fill-rule":"evenodd","d":"M19 31.16a9 9 0 00-9 9V61a9 9 0 009 9h42a9 9 0 009-9v-7.29h-7.58a3.13 3.13 0 110-6.26H70v-7.3a9 9 0 00-9-9H19z","clip-rule":"evenodd"}})])
          )
        }
      }
    